import TabsSlider from './TabsSlider';

export default TabsSlider;
